import * as React from 'react'
import {connect} from 'react-redux';
import * as equal from "fast-deep-equal";
import {isEmptyObject} from 'jquery';
import {hashHistory} from 'react-router';
import Loader from 'react-loader-advanced';
import {findIndex, isUndefined, isEmpty} from 'lodash'

import {auth} from '../../actions/auth';
import {createApiClient} from '../../services/ApiClient';
import {store} from '../../store';
import {RootState} from '../../store';
import {FormState} from "../../reducers";
import {ControlValueDispatcher, ValidationError} from '../controls/extensions/Dispatcher';
import {ErrorField, isGroupCheck, onValidate, validateControl} from '../controls/standart/validate';
import {
    setSection,
    addValue,
    addFile,
    checkedPanel,
    incrimentToSend,
    loadFrom,
    copyValue,
    recal,
    markVisited,
    setError,
    markAllVisited,
    openAlert
} from '../../actions';

import {ISectionSchema} from '../Section';
import {IGroupSchema} from "../controls/standart/Group";
import {IPanelSchema} from "../controls/standart/Panel";
import {ICalendarSchema} from "../controls/standart/Calendar/Calendar";
import {ControlErrorListItem, IControlError, IControlSchema} from '../Controls';

import * as Utils from '../../components/Utils'
import {I18NString, tr, goToAnchor} from "../Utils";
import RuleManager from '../../services/RulesManager';

import Sidebar from './Sidebar';
import Actions from './Actions';
import Content from './Content';
import Progress from './Progress';
import ConfirmModal from './ConfirmModal';
import RequestReportModal from './RequestReportModal';
import ReloadReportModal from './ReloadReportModal';

interface Props {
    schema: FormState
}

interface State {
    errorField: ErrorField;
    loader: boolean;
    func: (open) => void;
    anchorTo: {
        sectionId: string,
        controlId: string
    },
    anchoredTo: {
        sectionId: string,
        controlId: string
    }
}

interface RequestProps {
    params?: {
        form: string;
        values: number;
        id: string;
    },
    setSection: any,
    addValue: (id: string, value: any, refresh: boolean) => void,
    addFile: any,
    checkedPanel: (panelId: string, checked: boolean, error: IControlError | undefined) => void,
    incrimentToSend: any,
    loadFrom: any;
    copyValue: any;
    auth: any;
    recal: any;
    markVisited: (id: string) => void;
    setError: (id: string, error: IControlError) => void;
    markAllVisited: () => void;
    openAlertModal: (arg: string) => void;
}

interface SectionPercent {
    countRequired: number,
    countNotEmpty: number
}

interface IControlMode {
    SectionName: string;
    Readonly: boolean;
}

const REPORTS_IDS = [
    'ReportNumberOne',
    'ReportNumberTwo'
]

function recalPercentToSection(controls: Array<IControlSchema>,
    values: Array<any>,
    persent: SectionPercent,
    permissiblePanelIDs: Array<string>
) {
    for (let ctrl of controls) {
        const valueIdx = findIndex(values, (val: any) => val.controlid === ctrl.id);

        if (!ctrl.hasOwnProperty('controls') &&
            (isUndefined(ctrl.visible) || ctrl.visible)) {
            if (ctrl.required) {
                persent.countRequired++;
            }
            if (valueIdx > -1 && ctrl.required) {
                if(ctrl.type.toUpperCase() === 'CALENDAR' && (ctrl as ICalendarSchema).finishDate !== null) {
                    const value = values[valueIdx].value;
                    if(!isEmpty(value.beginDate) && !isEmpty(value.finishDate)) {
                        persent.countNotEmpty++
                    }
                }else {
                    persent.countNotEmpty++
                }
            }
        } else if (isGroupCheck(ctrl as IGroupSchema | IPanelSchema, values[valueIdx])) {
            //dynamic 
            if (ctrl.type.toUpperCase() === 'PANEL' &&
                valueIdx > -1 &&
                !isEmpty(values[valueIdx].value.rows)) {
    
                const rows = values[valueIdx].value.rows;
                for (let row of rows) {
                    for (let controlRow of row.controls) {
                        const index = findIndex(values, (val: any) => val.controlid === controlRow.id);
                        const idxCtrl = findIndex(ctrl["controls"], (obj: any) => obj.id === controlRow.name),
                            childControl = ctrl["controls"][idxCtrl];

                        if (childControl.required)
                            persent.countRequired++;

                        if (index > -1 && childControl.required)
                            persent.countNotEmpty++;
                    }
                }
            }

            recalPercentToSection(ctrl['controls'],
                values,
                persent,
                permissiblePanelIDs
            );
        } else if (ctrl.type.toUpperCase() === 'DYNAMICGRIDPANEL' && valueIdx > -1) {
            for(const element of values[valueIdx].value) {
                persent.countRequired += element.items.length;
                for(const item of element.items) {
                  const exist = values.some(t => t.controlid === item.name);
                  if(exist) {
                    persent.countNotEmpty++;
                  }
                }
              }
        }
    }
}

//35867
function visibleControls(state: any): Array<ISectionSchema> {
    const { form, values } = state;
    const sections = [...form.sections];
    const manager = new RuleManager();
    manager.run(sections, values)
    
    return sections;
}

function getSelection(sections: Array<ISectionSchema>, values: any, section: string): ISectionSchema {
    const index = findIndex(sections, (sec: any) => sec.id === section)

    return sections[index]
}

function getControlModeReadonly(readonly: boolean, controlMode: IControlMode[], section: string) {
    const existControlMode = controlMode && controlMode.length
    let newReadonly = readonly

    existControlMode && controlMode.map(item => {
        if (item.SectionName === section) {
            newReadonly = item.Readonly
        }
    })

    return newReadonly
}


function calcPercentSidebar(sections: Array<ISectionSchema>, values: any, checkedPanel: any) {
    return sections.map((sect: ISectionSchema): any => {
        return {
            id: sect.id,
            title: sect.title,
            percent: getPercent(sect, values, checkedPanel)
        }
    });
}

function getPercent(section: ISectionSchema, values: any, checkedPanel: any): number {
    if (!isUndefined(values) && values.length > 0) {
        let persent = {
            countRequired: 0,
            countNotEmpty: 0
        };
        recalPercentToSection(section.controls, values, persent, checkedPanel);

        return persent.countRequired > 0 ? parseInt((persent.countNotEmpty / persent.countRequired * 100).toString(), 0) : 0
    }

    return 0;
}

function getReadyReportsStatus(sections: Array<ISectionSchema>): boolean {
    // из значений sections получается новый объект { id: percent }, для быстрого поиска по сочетаниям id отчетов и процентам заполнения
    const sectionsPercents = sections.reduce((acc, item) => ({
        ...acc,
        [item.id]: item.percent
    }), {})

    // из константы с массивом id блоков "Отчёт" исходя из процентного состояния получаем массив заполненность с булевыми значениями
    const resultStates = REPORTS_IDS.map(item => sectionsPercents[item] === 100)

    // если нет ни одного false в массиве, то отчеты заполнены все и возвращаем true - кнопку можно показать
    return resultStates.indexOf(false) === -1
}

class Request extends React.Component<Props & RequestProps, State> {
    modal: ConfirmModal;
    requestModal: RequestReportModal;
    reloadModal: ReloadReportModal;

    constructor() {
        super();
        this.state = {
            errorField: null,
            loader: false,
            func: null,
            anchoredTo: {
                controlId: undefined,
                sectionId: undefined
            },
            anchorTo: {
                controlId: undefined,
                sectionId: undefined
            }
        }

        this.onValidateAndSend = this.onValidateAndSend.bind(this);
        this.onReportPDF = this.onReportPDF.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onDocument = this.onDocument.bind(this);
        this.onRevoke = this.onRevoke.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCopy = this.onCopy.bind(this);
    }

    componentWillMount() {
        const { form, values } = this.props.params;

        Utils.initLanguage("RU");

        this.dispather = new ControlValueDispatcher();
        this.dispather.addControlValue = this.addControlValue.bind(this);
        this.dispather.addFile = this.addFileValue.bind(this);
        this.dispather.addControlRefresh = this.addControlRefresh.bind(this);
        this.dispather.copyValue = this._handlerCopyValue.bind(this);
        this.dispather.error = this.frontError.bind(this);
        this.dispather.controlVisited = this.controlVisited.bind(this);

        this.props.auth();
        this.props.loadFrom(values, form);
    }

    controlVisited(id: string) {
        this.props.markVisited(id);
    }
    
    frontError(id: string, value: string, error: ValidationError | undefined, skipCommonValidation: boolean) {
        const control = this.findControl(id);
        const {errors} = this.props.schema;
        if(!control) {
            console.error(`control with id ${id} was not found`);
            return;
        }
        
        const existingError = errors[control.id];
        if(existingError && !existingError.isFrontValidation) {
            return;
        }
        
        if((control as any).disabled && !control.visible) {
            this.props.setError(id, undefined);
            return;
        }
        
        if(!error && !skipCommonValidation) {
            this.checkAndSetControlErrors(id, value, error, false);
            return;
        }
        
        this.props.setError(id, error && {
            isFrontValidation: true,
            message: error.message,
            isError: true
        });
    }

    componentDidUpdate(prevProps: Readonly<Props & RequestProps>, prevState: Readonly<State>): void {
        if(!equal(this.state.anchorTo, this.state.anchoredTo) && this.state.anchorTo.controlId) {
            if(goToAnchor(this.state.anchorTo.controlId)) {
                this.setState({anchoredTo: this.state.anchorTo});
            }
        }
        
        if(this.props.schema.section !== prevProps.schema.section) {
            this.clearAnchor();
        }
    }

    private clearAnchor() {
        this.setState({
            anchoredTo: {sectionId: undefined, controlId: undefined},
            anchorTo: {sectionId: undefined, controlId: undefined},
        });
    }

    private findControl(controlId: string): IControlSchema | undefined {
        return this.props.schema.form.sections
            .map(s => this.findControlInArray(controlId, s.controls))
            .find(s => s);
    }

    private findControlInArray(controlId: string, controls: any[]): IControlSchema | undefined {
        return controls
            .map(c =>  { 
                if(c.id === controlId){ 
                    return c;
                }
                if(c.controls) {
                    return this.findControlInArray(controlId, c.controls);
                }
                
                return undefined;
            })
            .find(s => s);
    }

    private dispather: ControlValueDispatcher;

    protected tr: (message: I18NString) => string = tr;

    _handlerCopyValue(sourceId: string, targetId: string) {
        this.props.copyValue(sourceId, targetId);
    }

    onSelected(id: string) { this.props.setSection(id) }

    addControlValue(id: string, value: any, valid: boolean, error: ValidationError) {
        this.checkAndSetControlErrors(id, value, error, false);
        this.props.addValue(id, value, false);
    }

    addControlRefresh(id: string, value: any, error: ValidationError) {
        this.checkAndSetControlErrors(id, value, error, false);
        this.props.addValue(id, value, true);
    }
    
    checkAndSetControlErrors(id: string, value: any, error: ValidationError, validateEmptyRequired: boolean) {
        let errors: ErrorField[] = [];
        if(!error || !error.message) {
            errors = this.checkForErrors(id, value, error, validateEmptyRequired);
            if(errors.filter(e => e.controlId === id).length <= 0) {
                errors.push({
                    controlId: id,
                    control: this.findControl(id),
                    error: undefined
                });
            }
        }
        else {
            errors.push({
                controlId: id,
                control: this.findControl(id),
                error: {
                    isFrontValidation: true,
                    message: error.message
                }
            });
        }
        this.setState({errorField: errors.find(e => !!e.error)});
        this.setMultipleErrors(errors);
    }
    
    checkForErrors(id: string, value: any, error: ValidationError, validateEmptyRequired: boolean): ErrorField[] {
        const control = this.findControl(id);
        if(control) {
            const values = this.props.schema.values.filter(v => v.controlid !== id);
            if(!isEmpty(value)) {
                values.push({controlid: id, value});
            }
            const controlError: IControlError = error && {
                isError: true,
                isFrontValidation: true,
                message: error.message
            };
            const existingErrors = {...this.props.schema.errors, [id]: controlError};
            const errors = Array.from(validateControl({
                ...control,
                value
            } as any, values, this.props.schema.form, validateEmptyRequired, existingErrors));
            return errors;
        }
        return [];
    }

    addFileValue(id: string, value: any, valid: boolean) {
        const { errorField } = this.state;

        if (errorField &&
            errorField.controlId === id) {
            this.setState({ errorField: undefined });
        }

        this.props.addFile(id, value);
    }

    /*Отправить документы*/
    onDocument() {
        const api = createApiClient(this.props.params.form);
        const { form, values } = this.props.schema;
        const self = this;

        this.props.markAllVisited();
        if(!this.validateForm(form, values, true)) {
            return;
        }

        self.setState({ loader: true });
        api.sendDocument({
            success: () => {
                self.setState({ loader: false });
                alert('Документы отправлены в АСУ');
                hashHistory.push('/');
            },
            error: (error, response) => {
                self.setState({ loader: false });
                if (!isUndefined(response)) {
                    const result = JSON.parse(response);
                    this.props.openAlertModal(result.errors[0].error.message);
                } else {
                    this.props.openAlertModal("Не удалось выполнить отправку");
                }
            }
        });
    }
    /*Отозвать заявку*/
    onRevoke() {
        const api = createApiClient(this.props.params.form);
        const self = this;
        if (confirm('Отозвать заявку?')) {
            this.setState({ loader: true });

            api.sendRevoke({
                success: () => {
                    self.setState({ loader: false });
                    alert('Ваша заявка отозвана');
                    hashHistory.push('/');
                },
                error: (error, response) => {
                    self.setState({ loader: false });
                    if (!isUndefined(response)) {
                        const result = JSON.parse(response);
                        this.props.openAlertModal(result.errors[0].error.message);
                    } else {
                        this.props.openAlertModal("Не удалось выполнить отправку");
                    }
                }
            });
        }
    }
    /*Получить PDF*/
    onReportPDF() {
        this.props.recal();
        this.props.markAllVisited();
        // props.recal() может поменять стейт и эти изменения должны быть видны дальше.
        // Вообще стоило бы какие-нибудь саги притащить, но времени нет.
        const state = store.getState();
        const schema = state.forms;
        const api = createApiClient(this.props.params.form);
        const { form } = schema;
        const self = this;
        
        if(!this.validateForm(form, schema.values)) {
            return;
        }

        const action = (open) => {
            if (open) {
                this.setState({ loader: true });
                api.sendPDF({
                    success: () => {
                        self.setState({ loader: false });
                        alert('Ваш запрос на формирование PDF обрабатывается');
                        hashHistory.push('/');
                    },
                    error: (_, response) => {
                        self.setState({ loader: false });
                        if (!isUndefined(response)) {
                            const result = JSON.parse(response);
                            if(result.errors[0].error.SumGrant){
                                this.props.setError('SumGrant', {
                                    isFrontValidation: false,
                                    message: result.errors[0].error.SumGrant,
                                    isError: true
                                });
                                this.props.setSection('GeneralInformation');
                                this.props.incrimentToSend();
                                return;
                            }else{
                                this.props.openAlertModal(result.errors[0].error.message);
                            }
                        } else {
                            this.props.openAlertModal("Не удалось выполнить отправку");
                        }
                    }
                });
            } 
        };
        this.setState({ func: action });
        this.modal.show();
    }

    onDelete() {
        const api = createApiClient(this.props.params.form);
        const self = this;
        if (confirm('Удалить заявку?')) {
            this.setState({ loader: true });
            api.deleteValues({
                success: () => {
                    self.setState({ loader: false });
                    hashHistory.push('/');
                },
                error: () => {
                    self.setState({ loader: false });
                    this.props.openAlertModal("Произошла ошибка в во время удаления заявки");
                }
            });
        }
    }

    onCopy(){
        const api = createApiClient(this.props.params.form);
        const self = this;

        if(confirm("Копировать заявку?")){
            this.setState({ loader: true });
            api.cloneRequest({
                success: () => {
                    self.setState({ loader: false });
                    hashHistory.push('/');
                },
                error: (status, error) => {
                    self.setState({ loader: false });
                    const data = JSON.parse(error);
                    if(data.errorMsg){
                        this.props.openAlertModal(data.errorMsg);
                    }else{
                        this.props.openAlertModal("Произошла ошибка в во время копирования заявки");
                    }
                    }
                });
        }
    }

    onValidateAndSend() {
        this.props.recal();
        this.props.markAllVisited();
        // props.recal() может поменять стейт и эти изменения должны быть видны дальше.
        // Вообще стоило бы какие-нибудь саги притащить, но времени нет.
        const state = store.getState();
        const schema = state.forms;
        const api = createApiClient(this.props.params.form);
        const self = this;
        
        const { form, values, status } = schema;
        
        if(!this.validateForm(form, values, true)) {
            return;
        }
    
        const action = (open) => {
            if(open) {
                this.setState({ loader: true });
                api.sendValues({
                    success: () => {
                        self.setState({ loader: false });
                        const reportStatuses = [12, 13, 14, 15, 16, 18];
                        reportStatuses.indexOf(status) !== -1 ? alert('Отчёт отправлен') : alert('Ваша заявка принята');
                        hashHistory.push('/');
                    },
                    error: (error, response) => {
                        self.setState({ loader: false });
                        if (!isUndefined(response)) {
                            const result = JSON.parse(response);
                            if(result.errors[0].error.SumGrant){
                                this.props.setError('SumGrant', {
                                    isFrontValidation: false,
                                    message: result.errors[0].error.SumGrant,
                                    isError: true
                                });
                                
                                this.props.setSection('GeneralInformation');
                                this.props.incrimentToSend();
                                return;
                            }else{
                                this.props.openAlertModal(result.errors[0].error.message);
                            }
                        } else {
                            this.props.openAlertModal("Не удалось выполнить отправку");
                        }
                    }
                });
            }
        }
        this.setState({ func: action });
        this.modal.show();
    }

    onAddition = () =>{
        const api = createApiClient(this.props.params.form);
        const { form, values } = this.props.schema;
        const self = this;
        const section = form.sections.find(t => t.id === 'AdditionalRequest');

        const validationResult = this.validateSection(section, form, values, true); 
        if(validationResult && validationResult.length > 0) {
            this.setMultipleErrors(validationResult);
            const actualErrors = validationResult.filter(v => !!v.error);
            if(actualErrors[0]) {
                this.scrollToSectionError(actualErrors[0], section.id);
                return;
            }
        }

        self.setState({ loader: true });
        api.sendAdditional({
            success: () => {
                self.setState({ loader: false });
                alert('Дозапрос отправлен в АСУ');
                hashHistory.push('/');
            },
            error: (error, response) => {
                self.setState({ loader: false });
                if (!isUndefined(response)) {
                    const result = JSON.parse(response);
                    this.props.openAlertModal(result.errors[0].error.message);
                } else {
                    this.props.openAlertModal("Не удалось выполнить отправку");
                }
            }
        });
    }

    private isPdf(): boolean {
        const { values } = this.props.schema;
        const requestPdf = findIndex(values, (obj: any) => obj.controlid == "RequestGrant");


        return requestPdf > -1;
    }

    getCheckedPanels(): Array<string>{
      const { form, values } = this.props.schema;
      const arr = [];
      for(let section of form.sections){
          for(let control of section.controls){
              if(control.hasOwnProperty('controls')){
                  const valueIdx = findIndex(values, (val: any) => val.controlid === control.id);
                  if(isGroupCheck(control as IGroupSchema | IPanelSchema, values[valueIdx])){
                      arr.push(control.id)
                  }
              }
          }
      }
      return arr;
    }
    
    collectSectionErrors(section: ISectionSchema): ControlErrorListItem[] {
        if(!section) {
            return [];
        }
        const errors = this.props.schema.errors;
        function* collectErrors(controls: IControlSchema[]): Iterable<ControlErrorListItem> {
            for (let control of controls) {
                const controlError = errors[control.id];
                if(controlError) {
                    const error: ControlErrorListItem = {
                        ...controlError,
                        controlId: control.id
                    }; 
                    yield error; 
                }
                
                if((control as any).controls) {
                    yield* collectErrors((control as any).controls);
                }
            }
        }
        
        return Array.from(collectErrors(section.controls));
    }

    onSubmitRequestReport = (data) => {
        const api = createApiClient();
        const {params: {form: formId, values: valuesId}} = this.props
        this.setState({loader: true})

        api.sendReport({
            data,
            action: 'report_deferral',
            formId,
            valuesId
        },{
            success: (res) => {
                this.setState({loader: false})
                this.requestModal.onClose();
                this.props.openAlertModal("Запрос отправлен");

                console.log("micro-success")
            },
            error: (status, error) => {
                this.setState({loader: false})
                if(status === 500) {
                    this.props.openAlertModal("Внутренняя ошибка сервера");
                }
                if(status === 413) {
                    this.props.openAlertModal("Превышен допустимый размер файлов в запросе продления срока отчёта");
                } else {
                    this.props.openAlertModal("Направить запрос не удалось");
                }
                // console.log(status);
                // console.log(error);
                // this.props.openAlertModal("Направить запрос не удалось");
            }
        })
    }

    onSubmitReloadReport = (data) => {
        const api = createApiClient();
        const {params: {form: formId, values: valuesId}} = this.props

        this.setState({loader: true})

        api.sendReport({
            data,
            action: 'clear_report',
            formId,
            valuesId
        },{
            success: (res) => {
                this.setState({loader: false})
                this.requestModal.onClose();
                window.location.reload();
            },
            error: (status, error) => {
                const reportNumber = {
                    12: 1,
                    14: 2
                }[data.status]

                this.setState({loader: false})
                this.props.openAlertModal(`Не удалось очистить Отчёт №${reportNumber}`);
            }
        })
    }

    render() {
        const { schema } = this.props;
        const {
            values,
            section,
            checkedPanel,
            status,
            countToSend,
            errors,
            visited,
            allVisited,
            form,
            readonly,
        } = schema;

        if (isEmptyObject(form) === false) {
            const { controlMode } = form;
            const sct = visibleControls(schema);
            const valuesSection = getSelection(sct, values, section);
            const sections = calcPercentSidebar(sct, values, checkedPanel);

            let errorField = this.collectSectionErrors(valuesSection);

            if (this.state.errorField && this.state.errorField.error) {
                errorField = [{
                    controlId: this.state.errorField.controlId,
                    message: this.state.errorField.error.message,
                    isError: true,
                    isFrontValidation: this.state.errorField.error.isFrontValidation
                },
                ...errorField];
            }

            const firstSectionErrorId = errorField[0] && errorField[0].controlId;

            return (
                <div id="content" className="nopad">
                    <Loader show={this.state.loader} message={(<span><span className="fa fa-spinner fa-spin"></span>Подождите, идет отправка...</span>)}>
                        <div className="reportbox">
                            <div className="reportbox-content-row">
                                <div className="reportbox-sidebar">
                                    <div className="reportbox-sidebar-heading">
                                        <span className="reportbox-sidebar-heading-title">{this.tr(form.title)}</span>
                                    </div>
                                    <div className="reportbox-sidebar-menu">
                                        <Sidebar items={sections}
                                            status={status}
                                            value={section}
                                            isClose={form.close && status === 0}
                                            onSelected={this.onSelected}>
                                        </Sidebar>
                                    </div>
                                </div>
                                <div className="reportbox-content-viewport">
                                    <Content
                                        section={valuesSection}
                                        api={createApiClient(this.props.params.form)}
                                        disableNumber={false}
                                        status={status}
                                        values={values}
                                        countToSend={countToSend}
                                        readonly={getControlModeReadonly(readonly, controlMode, section)}
                                        visited={visited}
                                        allVisited={allVisited}
                                        errors={errors}
                                        firstErrorId={firstSectionErrorId}
                                        dispatcher={this.dispather}>
                                    </Content>
                                </div>
                            </div>
                            <Progress sections={form.sections} checkPanel={this.getCheckedPanels()}  sectionPercent={sections}></Progress>
                            <Actions
                                onPDF={this.onReportPDF}
                                schema={form}
                                status={status}
                                formId={this.props.params.form}
                                onSend={this.onValidateAndSend}
                                onCopy={this.onCopy}
                                onDraft={() => hashHistory.push('/')}
                                onDocument={this.onDocument}
                                onRevoke={this.onRevoke}
                                onDelete={this.onDelete}
                                onAddition={this.onAddition}
                                isPdf={this.isPdf()}
                                isReportsReady={getReadyReportsStatus(sections)}
                                isVisible={isUndefined(readonly) ? true : !readonly}
                                onShowRequestModal={() => this.requestModal.show()}
                                onShowReloadModal={(event) => this.reloadModal.show(event, status)}
                            />
                        </div>
                    </Loader>
                    <ConfirmModal ref={ (modal) => this.modal = modal } func={this.state.func}>
                        <p>
                            Микрогранты в размере 100% планируемых или понесенных расходов предоставляются Участнику Исключительно в течении первого года (12 месяцев) с даты получения статуса
                        </p>
                    </ConfirmModal>
                    <RequestReportModal ref={node => this.requestModal = node} callback={this.onSubmitRequestReport} />
                    <ReloadReportModal ref={node => this.reloadModal = node} callback={this.onSubmitReloadReport} />
                </div>
            )
        }

        return (<div />)
    }

    setMultipleErrors(errorFields: ErrorField[]) {
        errorFields.forEach(e => this.props.setError(e.controlId, e.error && {isFrontValidation: true, isError: true, message: e.error.message}));
    }

    private validateForm(form: any, values, enabledControlsOnly: boolean = false): boolean {
        let firstInvalidSection: { sectionId: string, errorField: ErrorField } = undefined;
        for (let section of form.sections) {
            const validationErrors = this.validateSection(section, form, values, enabledControlsOnly);
            if(validationErrors) {
                this.setMultipleErrors(validationErrors);
                const realErrors = validationErrors.filter(e => e.error);
                if(realErrors.length > 0 && !firstInvalidSection) {
                    firstInvalidSection = { sectionId: section.id, errorField: realErrors[0] }
                }
            }
        }
        
        if(firstInvalidSection) {
            this.scrollToSectionError(firstInvalidSection.errorField, firstInvalidSection.sectionId);
            return false;
        }

        return true;
    }

    private validateSection(section: any, form: any, values, enabledControlsOnly: boolean = false): ErrorField[] {
        let errorFields = Array.from(onValidate(section.controls, values, form, true, this.props.schema.errors));
        if(enabledControlsOnly) {
            errorFields = errorFields.filter(errorField => !errorField.control.disabled);
        }
        
        return errorFields;
    }
    
    scrollToSectionError(errorField: ErrorField, sectionId: string) {
        this.setState({ errorField: errorField });
        this.props.incrimentToSend();
        if(this.props.schema.section === sectionId && goToAnchor(errorField.controlId)) {
            const anchored = {
                controlId: errorField.controlId,
                sectionId: sectionId
            };
            this.setState({
                anchorTo: anchored,
                anchoredTo: anchored
            });
        }else {
            this.props.setSection(sectionId);
            this.setState({
                anchorTo: {
                    controlId: errorField.controlId,
                    sectionId: sectionId
                },
                errorField
            });
        }
    }
}

const mapStateToProps = (state: RootState, ownProps: {}): Props => {
    return {
        schema: state.forms,
    };
};

const mapDispatchToProps = (dispatch: any): RequestProps => {
    return {
        setSection: (id: string) => dispatch(setSection(id)),
        addValue: (id: string, value: any, refresh: boolean) => dispatch(addValue(id, value, refresh)),
        addFile: (id: string, filename: string) => dispatch(addFile(id, filename)),
        checkedPanel: (panelId: string, checked: boolean, error: IControlError | undefined) => dispatch(checkedPanel(panelId, checked, error)),
        incrimentToSend: () => dispatch(incrimentToSend()),
        loadFrom: (valuesId: string, formId: string) => dispatch(loadFrom(valuesId, formId)),
        copyValue: (sourceId: string, targetId: string) => dispatch(copyValue(sourceId, targetId)),
        auth: () => dispatch(auth()),
        recal: () => dispatch(recal()),
        markVisited: (id: string) => dispatch(markVisited(id)),
        setError: (id: string, error: IControlError) => dispatch(setError(id, error)),
        markAllVisited: () => dispatch(markAllVisited()),
        openAlertModal: (msg) => dispatch(openAlert(msg)),
    };
};


export default connect<Props, RequestProps, {}>(mapStateToProps, mapDispatchToProps)(Request)


// WEBPACK FOOTER //
// ./src/components/request/index.tsx